import styled from "styled-components";

export const LoaderInnerWrap = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    background: rgba(29, 43, 100, 0.2);
`
